export default {"src":"/_next/static/media/cross-logo.35252d66.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};